











import PageSection from '@/uikit/components/AppDefaultLayout/components/sections/PageSection.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  components: { PageSection },
  props: {
    layoutGeneralConfig: {
      type: Object as () => LayoutConfig['general'],
    },
    layoutDataSet: {
      type: Object as () => LayoutDataSet,
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/specialSections/SpecialSections.vue